(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.eudemographic === "undefined") {
        jQuery.extend(sm.portal.vm, { eudemographic: {} });
    }

    function ExtractATO(demographic, demoMain){
        var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();

        if (!sm.portal.utility.isNullOrEmpty(demographic.CitizenshipID()) && demographic.CitizenshipID() > 0) {
            var citizenship = demoMain.Citizenships()[0];
            
            citizenship.PassportNumber = demographic.PassportNumber();
            citizenship.PermanentResidentStatusID = demographic.PermanentResidentFlagID();
            citizenship.VisaTypeID = demographic.VisaTypeID();
            citizenship.VisaExpirationDate = moment(demographic.VisaExpirationDate(), dateFormat).format('YYYY-MM-DD');
        }
    }

    jQuery.extend(true, sm.portal.vm.eudemographic, {
        ExtractATO: ExtractATO
    });

})(jQuery);